<template>
  <form-layout :label="label">
    <read-only-input :value="licenceValue" />
  </form-layout>
</template>

<script>
import {convertLicenceTypeCodeToName} from '@/constants/licence'
import FormLayout from '@/views/templates/FormLayout'
import ReadOnlyInput from "@/views/atoms/inputs/ReadOnlyInput";

export default {
  name: "LicenceBrowseItem",
  components: {
    FormLayout,
    ReadOnlyInput,
  },
  inject: [
    '$constant'
  ],
  props: {
    label: {
      type: String,
      required: false,
      default: '宅地建物取引業免許番号'
    },
    type: {
      type: [Number, null],
      required: true
    },
    number: {
      type: [String, null],
      required: true
    },
  },
  computed: {
    licenceValue() {
      return convertLicenceTypeCodeToName(this.type) + ' ' + this.number;
    }
  },
  methods: {
    doInput(event) {
      this.setTextHandler({value: event.target.value});
    },
    doChange(event) {
      this.setSelectHandler({value: event.target.value})
    }
  }
}
</script>
